import type { SiteData, TechKey } from './types';

export const TECHS: Record<TechKey, { name: string; uuid: string }> = {
  stripe: { name: 'Stripe', uuid: 'e0da30f9-f622-4c97-93ff-29bdbb135f75' },
  shopify: { name: 'Shopify', uuid: 'd513e568-ad32-44b5-b0c8-1b7d3fbe88a6' },
  hubspot: { name: 'HubSpot', uuid: 'a9e5c921-6753-4dd5-bbf1-d3e781a53414' },
  mixpanel: { name: 'Mixpanel', uuid: '26cd9529-de61-4704-9902-6de1a24485a0' },
  google_adsense: {
    name: 'Google Adsense',
    uuid: '795bae79-af8a-43e9-8f76-c7d62378d388',
  },
  segment: { name: 'Segment', uuid: '9da48b15-e461-4798-ac4b-49f727bbb7e3' },
  klaviyo: { name: 'Klaviyo', uuid: '40154e27-6038-4527-8469-71dd9ff4a7cf' },
  intercom: { name: 'Intercom', uuid: 'f48d9932-2638-426a-9ca8-d84a6b78fd6e' },
};

export const SITES: SiteData[] = [
  {
    host: 'luxebrand.store',
    color: '#e07850',
    techs: ['shopify', 'stripe', 'klaviyo'],
  },
  {
    host: 'gearcraft.io',
    color: '#5080d0',
    techs: ['stripe', 'mixpanel', 'segment'],
  },
  {
    host: 'brandnest.com',
    color: '#50a050',
    techs: ['hubspot', 'google_adsense', 'intercom'],
  },
  {
    host: 'fashionvault.co',
    color: '#9060d0',
    techs: ['shopify', 'stripe', 'mixpanel'],
  },
  {
    host: 'trendhaus.co',
    color: '#d05060',
    techs: ['shopify', 'hubspot', 'klaviyo'],
  },
  {
    host: 'pixelshop.io',
    color: '#3090b8',
    techs: ['shopify', 'stripe', 'segment'],
  },
  {
    host: 'zenyoga.com',
    color: '#60a860',
    techs: ['segment', 'google_adsense', 'intercom'],
  },
  {
    host: 'velocity.tools',
    color: '#6050c0',
    techs: ['google_adsense', 'hubspot', 'mixpanel'],
  },
];

export const MAX_URL_ROWS = 7;
export const LINE_HEIGHT = 21;
export const SCROLL_SPEED = 48;
export const SCAN_FRACTION = 0.42;
export const VIEWPORT_HEIGHT = 620;

// SITES is always indexed via modulo — out-of-bounds is impossible
export function getSite(index: number): SiteData {
  return SITES[index % SITES.length] as SiteData;
}
